export interface ArticleChapter {
  id: number;
  title: string;
  number: number;
  updatedAt: string;
  views: number;
}

export interface ArticleTag {
  name: string;
  slug: string;
}

export const articleChapters: Record<number, ArticleChapter[]> = {
  1: [
    { id: 101, title: '第1话 偶然的发现', number: 1, updatedAt: '2026-01-10', views: 52000 },
    { id: 102, title: '第2话 心跳加速', number: 2, updatedAt: '2026-01-17', views: 48500 },
    { id: 103, title: '第3话 无法言说的秘密', number: 3, updatedAt: '2026-01-24', views: 46100 },
  ],
  6: [
    { id: 601, title: '第1话 相遇', number: 1, updatedAt: '2025-11-05', views: 68000 },
    { id: 602, title: '第2话 命运的玩笑', number: 2, updatedAt: '2025-11-12', views: 63500 },
    { id: 603, title: '第3话 抉择', number: 3, updatedAt: '2025-11-19', views: 61200 },
  ],
};

export const generateChapters = (comicId: number, totalChapters: number): ArticleChapter[] => {
  const baseDate = new Date('2025-06-01');
  return Array.from({ length: totalChapters }, (_, i) => ({
    id: comicId * 1000 + i + 1,
    title: `第${i + 1}话`,
    number: i + 1,
    updatedAt: new Date(baseDate.getTime() + i * 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    views: Math.floor(Math.random() * 30000) + 20000,
  })).reverse();
};

export const articleTags: ArticleTag[] = [
  { name: '韩漫推荐', slug: 'recommend' },
  { name: '热门连载', slug: 'hot' },
  { name: '新作上线', slug: 'new' },
  { name: '完结佳作', slug: 'completed' },
];

export const articleContent = `虚空韩漫网致力于为广大韩漫爱好者提供最优质的在线阅读体验。作为一个专注于韩国漫画的在线阅读平台，我们收录了大量正版韩漫资源，涵盖恋爱、奇幻、动作、悬疑等多种类型。

我们的阅读器采用高清下拉式设计，让您无需翻页即可流畅阅读整部漫画。无论您使用电脑还是手机，都能获得舒适的阅读体验。

每部漫画都经过精心整理，章节排列清晰，更新及时。您可以轻松追踪自己喜欢的作品，不错过任何更新。

虚空韩漫网坚持正版合规运营，所有漫画内容均获得授权。我们相信，只有尊重创作者权益，才能让韩漫行业持续健康发展。`;